import script from "./CommonDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CommonDialog.vue?vue&type=style&index=0&id=69b41566&lang=scss"

const __exports__ = script;

export default __exports__